import Spinner from '~components/Spinner';

import * as S from './style';

export interface LoadingProps {
  height?: number;
  size?: number;
}
function LoadingCircle({ height, size = 56 }: LoadingProps) {
  return (
    <S.LoadingWrapper height={height}>
      <Spinner width={size} height={size} />
    </S.LoadingWrapper>
  );
}

export default LoadingCircle;
